'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _components = require('../../components');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _reactIntl = require('react-intl');

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RegisterLink = require('./RegisterLink.scss');

var _RegisterLink2 = _interopRequireDefault(_RegisterLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RegisterLink = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(RegisterLink, _Component);

    function RegisterLink() {
        (0, _classCallCheck3.default)(this, RegisterLink);
        return (0, _possibleConstructorReturn3.default)(this, (RegisterLink.__proto__ || (0, _getPrototypeOf2.default)(RegisterLink)).apply(this, arguments));
    }

    (0, _createClass3.default)(RegisterLink, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['className', 'catalogId', 'isCatalogOnly', 'registrationStatus']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                catalogId = _props.catalogId,
                className = _props.className,
                isCatalogOnly = _props.isCatalogOnly,
                openRegisterForCatalogModal = _props.openRegisterForCatalogModal,
                registrationStatus = _props.registrationStatus,
                requestOnlineBidding = _props.requestOnlineBidding;
            var declined = registrationStatus.declined,
                pending = registrationStatus.pending;


            var registeredMessage = void 0;
            if (declined) {
                registeredMessage = 'registration_declined';
            } else if (isCatalogOnly) {
                registeredMessage = 'request_submitted';
            } else {
                registeredMessage = pending ? 'registration_pending' : 'registration_approved';
            }

            if (!(0, _isEmpty2.default)(registrationStatus)) {
                return (0, _jsx3.default)('span', {
                    className: _RegisterLink2.default.registered + ' ' + className
                }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                    id: registeredMessage
                }));
            }

            if (isCatalogOnly) {
                return (0, _jsx3.default)(_components.ShouldLogInContainer, {
                    requireLogin: true,
                    requireCompleteProfile: true,
                    runFunction: requestOnlineBidding,
                    runFunctionArgument: catalogId
                }, void 0, (0, _jsx3.default)(_components.Link, {
                    className: _RegisterLink2.default['register-for-auction'] + ' ' + className
                }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                    id: 'request_online_bidding'
                })));
            }

            return (0, _jsx3.default)(_components.ShouldLogInContainer, {
                requireLogin: true,
                requireCompleteProfile: true,
                runFunction: openRegisterForCatalogModal,
                runFunctionArgument: { catalogId: catalogId }
            }, void 0, (0, _jsx3.default)(_components.Link, {
                className: _RegisterLink2.default['register-for-auction'] + ' ' + className
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'register_to_bid'
            })));
        }
    }]);
    return RegisterLink;
}(_react.Component), _class.defaultProps = {
    className: ''
}, _temp);
exports.default = RegisterLink;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/RegisterLink/RegisterLink.js
// module id = KaKp
// module chunks = 46